import { useState } from "react";
import UploadCard from "../UploadCard";
import ResultCard from "../ResultCard";

export default function DemoSection() {
  const [result, setResult] = useState(null);

  return (
    <section id="demo" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">
            <span className="font-mono-num">08</span> · Try it
          </div>
          <h2 className="font-heading mt-4 text-4xl sm:text-5xl tracking-tight font-light text-slate-900">
            Feed it an image. <br />
            <span className="text-slate-400">See what happens.</span>
          </h2>
          <p className="mt-5 text-slate-600 max-w-xl">
            This is a public demo. Upload any skin image and watch the agents
            reason. For persistent history and exportable reports, create a
            doctor account.
          </p>
        </div>

        <div className="mt-10 grid lg:grid-cols-2 gap-6 items-start">
          <UploadCard onResult={setResult} requireAuth={false} />
          <div>
            {result ? (
              <ResultCard result={result} />
            ) : (
              <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50/60 p-10 text-center">
                <div className="text-[10px] uppercase tracking-[0.22em] font-mono-num text-slate-400">
                  Awaiting analysis
                </div>
                <div className="mt-3 font-heading text-xl text-slate-700">
                  Your prediction will appear here.
                </div>
                <div className="mt-2 text-sm text-slate-500">
                  Upload any skin image on the left and hit Analyse.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
